<template>
  <div class="paybox">
    <p class="pb-tit">充值成功!
    </p>
    <p>
      <label>订单编号：</label><span>{{ theRequest.out_trade_no }}</span>
    </p>
    <p>
      <label>充值渠道：</label><span>官网充值</span>
    </p>
    <p>
      <label>充值金额：</label><span>{{theRequest.total_amount}}</span>
    </p>
    <p>
      <label>充值时间：</label><span>{{theRequest.timestamp }}</span>
    </p>
    <p>
      <label>充值结果：</label><span>充值成功</span>
    </p>
    <button type="button" name="button" @click="toRecharge">继续充值</button>
  </div>
</template>
<script>
  export default {
    name:'paysuccess',
    data () {
      return {
        theRequest:{}
      }
    },
    created(){
			this.$store.commit('inWhichPage',{page:'isPaySuccess'})
		},
    methods:{
      toRecharge(){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        let name = '/recharge';
        if (flag) {
          name = '/mobilrecharge'
        }
        this.$router.push(name);
      }
    },
    mounted(){
      var url = decodeURIComponent(window.location.search); //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for(var i = 0; i < strs.length; i ++) {
          theRequest[strs[i].split("=")[0]]=decodeURI(strs[i].split("=")[1]);
        }
      }
      this.theRequest = theRequest ;
    }
  }
</script>
<style scoped>
  .paybox{
    width:300px;
    min-width: 300px;
    margin: 220px auto 20px;
    text-align: left;
  }

  .paybox p.pb-tit{
    font-size: 36px;
    color: #13C929;
    text-align: left;
    margin-bottom: 20px;
    background: url("../assets/icon_pay_right_normal.png") no-repeat 170px  3px ;
    background-size: 44px;
    height: 50px;
    line-height: 50px;
  }
  .pb-tit img{
    width: 44px;
  }

  .paybox p{
    font-size: 16px;
    color: #888888;
    line-height: 40px;
  }
  .paybox p label{
    color: #232323;
  }

  .paybox button{
    border: none;
    color: #FFFFFF;
    width: 220px;
    height: 44px;
    background: #F33D1C;
    margin-top: 20px;
    font-size: 18px;
    border-radius: 6px;
    cursor: pointer;
    outline: none;
  }

  .paybox button:hover{
    opacity: .9;
  }
</style>



// WEBPACK FOOTER //
// src/page/paysuccess.vue